import React from 'react'
import { useQuery } from 'react-apollo'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'

import { useRestaurant } from '../../../RestaurantProvider/RestaurantProvider'
import { ModeLink } from '../../../ModeRouter/ModeRouter'
import { LOYALTY_GET_COMPLETED_ORDER } from '../../LoyaltyConfirmation.graphql'
import { LOYALTY, LearnMoreButton, useTermsModal } from '../../../TermsModal/TermsModal'

import Flare from '../../../../assets/flare.svg'
import '../../LoyaltyConfirmation.css'

const getLoyaltyMessaging = ({ hasLoyaltyAttached, loyaltySignupBonus }) => {
  if (hasLoyaltyAttached) {
    return {
      title: 'Your points are waiting...',
      description: 'You\'re already earning points! Create an account and put them towards exclusive rewards that can save you money.',
      button: 'Create Account'
    }
  }

  return {
    title: 'Don\'t let your points go to waste!',
    description: loyaltySignupBonus
      ? `Earn points for this order and another ${loyaltySignupBonus} just for joining our reward program.`
      : 'Earn points for this order by joining our reward program.',
    button: 'Start Earning'
  }
}

export const LoyaltyAccountCreation = ({ orderGuid, setIntentToEnroll }) => {
  const { restaurantGuid } = useRestaurant()
  const transactionGuid = uuid()
  const { data, loading, error } = useQuery(LOYALTY_GET_COMPLETED_ORDER, {
    variables: {
      input: {
        orderGuid,
        restaurantGuid
      }
    }
  })

  const { TermsModal, openModal } = useTermsModal({ terms: LOYALTY })

  if (loading || error) return null
  const {
    customerV2: customer,
    hasLoyaltyAttached,
    restaurant: {
      loyaltyConfig: { loyaltySignupBonus }
    },
    checkGuid: checkIdentifier
  } = data.completedOrder

  let loyaltyAccountCreationInput
  if (!hasLoyaltyAttached) {
    loyaltyAccountCreationInput = {
      restaurantGuid,
      transactionGuid,
      checkIdentifier
    }
  }

  const basicInfo = {
    firstName: customer.firstName,
    lastName: customer.lastName,
    phone: customer.phone
  }

  const { title, description, button } = getLoyaltyMessaging({ hasLoyaltyAttached, loyaltySignupBonus })
  return (
    <div styleName='container'>
      <TermsModal />
      <Flare />
      <h2 styleName='title'>{title}</h2>
      <p styleName='description'>{description}</p>
      <ModeLink
        onClick={setIntentToEnroll}
        data-testid='button-loyalty-signup'
        mode='create'
        state={{
          signupSource: 'LOYALTY_SIGNUP',
          email: customer.email,
          basicInfo,
          loyaltyAccountCreationInput
        }}
        style='primaryWide'
      >
        {button}
      </ModeLink>
      {!hasLoyaltyAttached && (
        <LearnMoreButton
          styleName='infoButton'
          onClick={openModal}
          data-testid='button-loyalty-more-info'
        />
      )}
    </div>
  )
}

LoyaltyAccountCreation.propTypes = {
  setIntentToEnroll: PropTypes.func.isRequired,
  orderGuid: PropTypes.string.isRequired
}
